import { render, staticRenderFns } from "./listaProdutosLegada.vue?vue&type=template&id=508d4cfe&scoped=true"
import script from "./listaProdutosLegada.vue?vue&type=script&lang=js"
export * from "./listaProdutosLegada.vue?vue&type=script&lang=js"
import style0 from "./listaProdutosLegada.vue?vue&type=style&index=0&id=508d4cfe&prod&lang=css"
import style1 from "./listaProdutosLegada.vue?vue&type=style&index=1&id=508d4cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d4cfe",
  null
  
)

export default component.exports